<template>
  <section id="search-job">
    <JobPortalList></JobPortalList>
  </section>
</template>

<script>
import JobPortalFilters from '@/components/JobPortal/JobPortalFilters';
import JobPortalList from '@/components/JobPortal/JobPortalList';

export default {
  components: {
    JobPortalFilters,
    JobPortalList,
  },
};
</script>
